var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('el-tooltip',{attrs:{"content":_vm.content,"placement":_vm.placement}},[_c('i',{staticClass:"el-icon-question",staticStyle:{"cursor":"pointer"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }